export const CONTACT_EMAIL = "consulting@benzenati.com";

export const NAV_LINKS = [
  { label: "Accueil", to: "/" },
  { label: "Veille & Décryptages", to: "/veille" },
  { label: "Ressources", to: "/ressources" },
  { label: "La lettre BENZENATI", to: "/newsletter" },
  { label: "À propos", to: "/a-propos" },
];
